import { JSX } from 'solid-js';

const DEFAULT_WIDTH = 205;
const DEFAULT_HEIGHT = 32;

interface TrimbleLogoProps {
  width?: number | string;
  height?: number | string;
}

export const TrimbleLogo = (props: TrimbleLogoProps): JSX.Element => {
  return (
    <svg
      width={props.width ?? DEFAULT_WIDTH}
      height={props.height ?? DEFAULT_HEIGHT}
      viewBox="0 0 170 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="text-gray-900 dark:text-white"
      role="img"
      aria-label="Trimble Logo"
    >
      <title>Trimble Logo</title>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M99.0864 11.0759C99.0864 6.72793 101.474 3.67993 105.065 3.67993C107.977 3.67993 109.588 5.40793 110.268 8.06693L108.948 8.39693C108.307 6.12593 107.239 4.94193 105.046 4.94193C102.27 4.94193 100.464 7.34893 100.464 11.0369C100.464 15.0159 102.289 17.3459 105.085 17.3459C107.22 17.3459 108.56 16.1039 109.181 13.6969L110.501 13.9879C109.802 16.8219 107.938 18.5889 105.065 18.5889C101.435 18.5889 99.0864 15.6579 99.0864 11.0759Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M120.072 13.1921C120.072 10.9601 118.946 9.03709 116.791 9.03709C114.714 9.03709 113.491 10.7841 113.491 13.1921C113.491 15.4631 114.597 17.3851 116.791 17.3851C118.849 17.3851 120.072 15.6571 120.072 13.1921ZM112.152 13.2111C112.152 9.79509 114.268 7.89209 116.791 7.89209C119.296 7.89209 121.411 9.79509 121.411 13.2111C121.411 16.6081 119.296 18.5301 116.791 18.5301C114.287 18.5301 112.152 16.6081 112.152 13.2111Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M123.473 8.08658H124.812V9.69758C125.803 8.72658 127.103 7.89258 128.714 7.89258C130.733 7.89258 131.762 9.01858 131.762 10.9206V18.3166H130.423V11.1726C130.423 9.73658 129.782 9.03758 128.384 9.03758C127.064 9.03758 125.958 9.71658 124.812 10.8236V18.3166H123.473V8.08658Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M134.304 8.08658H135.643V9.69758C136.634 8.72658 137.934 7.89258 139.545 7.89258C141.564 7.89258 142.593 9.01858 142.593 10.9206V18.3166H141.254V11.1726C141.254 9.73658 140.613 9.03758 139.215 9.03758C137.895 9.03758 136.789 9.71658 135.643 10.8236V18.3166H134.304V8.08658Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M151.959 12.3958C151.823 10.4548 150.891 9.01882 149.066 9.01882C147.591 9.01882 146.213 10.0858 145.96 12.3958H151.959ZM144.602 13.1918C144.602 9.56182 146.931 7.89282 149.086 7.89282C151.474 7.89282 153.26 9.71682 153.26 13.2108V13.4638H145.941C145.96 15.9868 147.397 17.4048 149.164 17.4048C150.697 17.4048 151.571 16.7448 152.347 15.5408L153.182 16.2008C152.289 17.6378 151.027 18.5308 149.086 18.5308C146.698 18.5308 144.602 16.6868 144.602 13.1918Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M154.817 13.2111C154.817 9.54209 157.088 7.89209 159.379 7.89209C161.572 7.89209 162.659 9.19309 163.3 10.6881L162.155 11.1921C161.592 9.81409 160.776 9.03709 159.34 9.03709C157.826 9.03709 156.156 10.1251 156.156 13.1921C156.156 15.8711 157.515 17.3851 159.301 17.3851C160.718 17.3851 161.514 16.7251 162.233 15.2111L163.319 15.6761C162.504 17.4041 161.32 18.5301 159.243 18.5301C156.894 18.5301 154.817 16.6081 154.817 13.2111Z"
        fill="currentColor"
      />
      <mask
        id="mask0_28_80"
        // eslint-disable-next-line @typescript-eslint/naming-convention
        style={{ 'mask-type': 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="164"
        y="4"
        width="6"
        height="15"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M164.195 4.41699H170V18.452H164.195V4.41699Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_28_80)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M165.981 15.929V9.23199H164.195V8.08699H165.981V4.41699H167.32V8.08699H169.98V9.23199H167.32V15.658C167.32 16.744 167.67 17.327 168.932 17.327C169.32 17.327 169.709 17.288 170 17.191V18.336C169.689 18.394 169.146 18.452 168.679 18.452C166.719 18.452 165.981 17.696 165.981 15.929Z"
          fill="currentColor"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.9131 18.3167V6.20366H27.4871V3.95166H38.7661V6.20366H34.3391V18.3167H31.9131Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M38.4067 18.3167V8.0087H40.7947V9.6977H40.8337C41.4737 8.6687 42.5807 7.8147 44.5407 7.8147H44.6967L44.6187 10.0077C44.5017 9.9887 44.1137 9.9697 43.9777 9.9697C42.4447 9.9697 41.4737 10.6877 40.7947 11.7947V18.3167H38.4067Z"
        fill="currentColor"
      />
      <mask
        id="mask1_28_80"
        // eslint-disable-next-line @typescript-eslint/naming-convention
        style={{ 'mask-type': 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="170"
        height="23"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 22.4165H170V0.000488281H0V22.4165Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_28_80)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M45.989 18.3165H48.396V8.00851H45.989V18.3165ZM45.97 6.22251H48.416V4.14551H45.97V6.22251Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M50.6309 18.3167V8.0087H53.0189V9.4257C53.8149 8.5517 54.9789 7.8147 56.5519 7.8147C58.2789 7.8147 58.9589 8.4937 59.3659 9.5037C60.1819 8.6107 61.4049 7.8147 62.9769 7.8147C65.0739 7.8147 65.9859 9.0767 65.9859 10.9207V18.3167H63.5979V11.5227C63.5979 10.3777 63.2679 9.8527 62.1419 9.8527C61.1719 9.8527 60.3949 10.3967 59.5029 11.1927V18.3167H57.1149V11.5227C57.1149 10.3777 56.7849 9.8527 55.6589 9.8527C54.7079 9.8527 53.9119 10.3967 53.0189 11.1927V18.3167H50.6309Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M75.5396 13.1727C75.5396 10.9987 74.6076 9.85266 73.0746 9.85266C72.0836 9.85266 71.1326 10.4747 70.5696 11.1537V15.2887C71.2106 16.1237 72.1426 16.5697 72.9966 16.5697C74.8016 16.5697 75.5396 15.4637 75.5396 13.1727ZM70.5696 17.1717V18.3167H68.1826V3.95166H70.5696V9.36766C71.2486 8.55166 72.3166 7.81466 73.8506 7.81466C76.1996 7.81466 77.9276 9.58166 77.9276 13.1527C77.9276 16.7247 76.1606 18.4717 73.5206 18.4717C72.4146 18.4717 71.3276 18.0257 70.5696 17.1717Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M79.719 18.3164H82.126V3.95142H79.719V18.3164Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M91.0869 12.1629C90.9509 10.5909 90.1749 9.75594 88.7379 9.75594C87.5739 9.75594 86.5059 10.4159 86.2729 12.1629H91.0869ZM83.8459 13.1729C83.8459 9.25094 86.6219 7.81494 88.7569 7.81494C91.0679 7.81494 93.2809 9.19294 93.2809 13.3859V13.9489H86.2339C86.3309 15.8129 87.4769 16.6279 88.9909 16.6279C90.3299 16.6279 91.1069 16.1819 91.8829 15.4249L93.1449 16.6669C92.0769 17.8509 90.6599 18.5309 88.8159 18.5309C86.2339 18.5309 83.8459 16.9579 83.8459 13.1729Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.70652 0.000244141L19.4135 5.60424V9.34024L15.0995 11.8312V8.09524L5.39252 2.49124L9.70652 0.000244141Z"
          fill="currentColor"
          class="text-blue dark:text-blue-light"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.4131 16.8123L9.70607 22.4163L6.47107 20.5493V15.5673L9.70607 17.4353L19.4131 11.8313V16.8123Z"
          fill="currentColor"
          class="text-blue dark:text-blue-light"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.000488281 16.8124V5.60435L3.23449 3.73535L7.54949 6.22635L4.31349 8.09435L4.31449 19.3034L0.000488281 16.8124Z"
          fill="currentColor"
          class="text-blue dark:text-blue-light"
        />
      </g>
    </svg>
  );
};
